// components/AccordionItem.js
"use client";
import Link from "next/link";

const AccordionItem = ({ item, isOpen, onClick }) => {
  return (
    <div className="group overflow-hidden rounded-lg bg-dark-surface shadow-primary-sm hover:shadow-primary-md transition-all duration-200 border border-dark-border">
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between p-4 sm:p-6 text-left"
        aria-expanded={isOpen}
      >
        <div className="flex items-start space-x-3">
          <div
            className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
              isOpen
                ? "bg-primary-transparent text-primary-500"
                : "bg-neutral-700 text-dark-text-secondary"
            }`}
          >
            <span className="text-base font-medium">{item.id}</span>
          </div>
          <h3
            className={`text-lg sm:text-xl font-medium ${
              isOpen ? "text-primary-500" : "text-dark-text-primary"
            }`}
          >
            {item.question}
          </h3>
        </div>
        <div
          className={`ml-2 shrink-0 transform transition-transform duration-200 ${
            isOpen ? "rotate-180 text-primary-500" : "text-dark-text-secondary"
          }`}
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>

      <div
        className={`transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 opacity-100 pb-4 sm:pb-6" : "max-h-0 opacity-0"
        }`}
      >
        <div className="pl-10 pr-4 sm:pl-16 sm:pr-6">
          <p className="text-base sm:text-lg text-dark-text-secondary leading-relaxed whitespace-pre-line">
            {item.answer}
          </p>
          {item.id === 4 && (
            <button className="mt-3 inline-flex items-center px-3 py-1 text-base sm:text-lg font-medium text-secondary-500 bg-secondary-transparent rounded-md hover:bg-secondary-600 hover:text-white transition-colors">
              View Hosting Plans
              <svg className="ml-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;